import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { CLIENT_APPLICATION_STATUS } from "@Shared/js/enum";
import Badge from "@Shared/components/general/badge.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ConsolidatedRequestApplicationShared",
  components: {
    Badge
  },
  props: {
    sharedApplications: {
      type: Array,
      default: () => []
    },
    isMultiBorrowerRequest: {
      type: Boolean,
      default: false
    },
    expandOnInit: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      expanded: false
    };
  },
  computed: {
    filteredSharedApplications() {
      var _context;
      return _filterInstanceProperty(_context = this.sharedApplications).call(_context, ({
        fillOut
      }) => fillOut.length);
    }
  },
  mounted() {
    this.expanded = this.expandOnInit;
  },
  methods: {
    toggleExpand() {
      this.expanded = !this.expanded;
    },
    getBadgeType(status) {
      switch (status) {
        case CLIENT_APPLICATION_STATUS.pending:
        case CLIENT_APPLICATION_STATUS.new:
          return "bg-light-gray text-white";
        case CLIENT_APPLICATION_STATUS.submitted:
        case CLIENT_APPLICATION_STATUS.inReview:
        case CLIENT_APPLICATION_STATUS.completed:
          return "badge-success";
        default:
          return "badge-danger";
      }
    },
    getSharedApplicationSections(applicant) {
      var _context2;
      return _mapInstanceProperty(_context2 = applicant.fillOut).call(_context2, ({
        key
      }) => this.$t(`application-form.${key}`)).join(", ");
    }
  }
});